import { blobURLFromSrc } from './util/blobs';

export class LocalServiceWorker {
	/**
	 * @type {Promise<Worker>}
	 */
	worker;

	requests = new Map();

	constructor(src, name) {
		/*
		 * Reverting to regular worker URL's here until we can fix URL resolution
		 * for child workers using Blobs.
		 *
		this.worker = blobURLFromSrc(src).then(uri => {
			const worker = new Worker(uri, {name});
			worker.onmessage = m => this.handleMessage(m);
			return worker;
		});
		*/

		// Keeping as a promise so consumer can .then() it.
		const worker = new Worker(src, {name});
		worker.onmessage = m => this.handleMessage(m);
		this.worker = Promise.resolve(worker);
	}

	handleMessage(message) {
		const { requestId, event, progress, result, error } = message.data;
		const request = this.requests.get(requestId);
		if (!request) return;

		if (event == 'progress') {
			request.onprogress?.(progress);
		} else if (event == 'complete') {
			this.requests.delete(requestId);
			request.oncomplete?.(result);
		} else if (event == 'error') {
			this.requests.delete(requestId);
			request.onerror?.(error);
		}
	}

	execute({
		method,
		args,
		oncomplete,
		onprogress,
		onerror
	}) {
		const requestId = `${new Date().getTime()}.${Math.random()}`;
		this.requests.set(requestId, { oncomplete, onprogress, onerror });
		this.worker.then(w => {
			w.postMessage({ requestId, method, args })
		});
	};
};
